import { useEffect } from 'react';
import { FormSection } from '../../../../../common/components/ui/Form/FormSection/FormSection';
import { FormDatePicker } from '../../../../../common/components/ui/Form/FormDatePicker/FormDatePicker';
import {
  Button,
  ButtonSize,
  ButtonVariant
} from '../../../../../common/components/ui/Button';
import { useVacationDaysAmount } from '../../../../../common/hooks/useDayOffs';
import s from './VacationAppChildPeriod.module.scss';

export interface VacationChildPeriodProps {
  start: string;
  end: string;
  index: number;
  mainFieldName: string;
  minStartDate?: Date | null;
  maxStartDate?: Date | null;
  minEndDate?: Date | null;
  maxEndDate?: Date | null;
  excludeDates?: Date[] | undefined;
  onRemovePeriod: (index: number) => void;
  setFieldValue;
}

export const VacationAppChildPeriod = ({
  index,
  start,
  end,
  mainFieldName,
  onRemovePeriod,
  minStartDate,
  maxStartDate,
  minEndDate,
  maxEndDate,
  excludeDates,
  setFieldValue
}: VacationChildPeriodProps) => {
  const fieldName = `${mainFieldName}[${index}]`;

  const selectedDaysAmount = useVacationDaysAmount({
    startDate: start,
    endDate: end
  });

  useEffect(() => {
    setFieldValue(`${fieldName}.days`, selectedDaysAmount || 0);
  }, [fieldName, selectedDaysAmount, setFieldValue]);

  const periodStart = `${mainFieldName}[${index}].start`;
  useEffect(() => {
    setFieldValue(`${mainFieldName}[${index}].end`, undefined);
  }, [index, mainFieldName, periodStart, setFieldValue]);

  return (
    <div className={s.VacationChildPeriod}>
      <FormSection>
        <FormDatePicker
          name={`${mainFieldName}[${index}].start`}
          label={'Дата начала периода *'}
          placeholder={'Выберите дату'}
          minDate={minStartDate}
          maxDate={maxStartDate}
          excludeDates={excludeDates}
        />
        <FormDatePicker
          name={`${mainFieldName}[${index}].end`}
          label={'Дата окончания периода *'}
          placeholder={'Выберите дату'}
          minDate={minEndDate}
          maxDate={maxEndDate}
          excludeDates={excludeDates}
        />
        <Button
          className={s.VacationChildPeriod__removePeriodButton}
          variant={ButtonVariant.tertiary}
          size={ButtonSize.small}
          onClick={() => onRemovePeriod(index)}
        >
          -
        </Button>
      </FormSection>
    </div>
  );
};
